<template>
  <div
    class="button-copy"
    @click="saveToBuffer(value)">
    <slot />
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.66638 10.6664V2.66635C4.66656 1.56204 5.56207 0.666527 6.66638 0.666351H9.78943C10.3121 0.666351 10.8142 0.871352 11.1879 1.23666L13.3978 3.3978C13.7827 3.77404 14.0003 4.28938 14.0004 4.82748V10.6664C14.0004 11.7708 13.1048 12.6662 12.0004 12.6664H6.66638C5.56197 12.6662 4.66638 11.7708 4.66638 10.6664ZM6.00037 10.6664C6.00037 11.0344 6.29833 11.3332 6.66638 11.3333H12.0004C12.3684 11.3332 12.6664 11.0345 12.6664 10.6664V4.82748C12.6663 4.64816 12.5944 4.47625 12.4662 4.35092L10.2562 2.18979C10.1316 2.06797 9.96365 2.00034 9.78943 2.00034H6.66638C6.29845 2.00051 6.00054 2.29842 6.00037 2.66635V10.6664Z"
        fill="#1E2128" />
      <path
        d="M6.00037 10.6664C6.00037 11.0344 6.29833 11.3332 6.66638 11.3333H12.0004C12.3684 11.3332 12.6664 11.0345 12.6664 10.6664V4.82748C12.6663 4.64816 12.5944 4.47625 12.4662 4.35092L10.2562 2.18979C10.1316 2.06797 9.96365 2.00034 9.78943 2.00034H6.66638C6.29845 2.00051 6.00054 2.29842 6.00037 2.66635V10.6664Z"
        fill="#1E2128" />
      <path
        d="M10.6666 12V13.3333C10.6666 14.0697 10.0697 14.6667 9.33329 14.6667H3.99996C3.26358 14.6667 2.66663 14.0697 2.66663 13.3333V5.99999C2.66663 5.26361 3.26358 4.66666 3.99996 4.66666H5.33329"
        stroke="#1E2128"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  methods: {
    saveToBuffer(value) {
      this.$copyText(value);
    },
  },
};
</script>

<style lang="scss">
.button-copy {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
  border: none;
}
</style>
